import { useEffect, useState } from "react";
import PropertyCard from "./PropertyCard";
import { useNavigate } from "react-router-dom";
import api from "../../common/apiClient";
import SummaryApi from "../../common/SummaryApi";
import Image from "../../assets/Property.png";
import { FaArrowRightLong } from "react-icons/fa6";

export default function ExploreProperties() {
  const [properties, setProperties] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchProperties = async () => {
      try {
        const res = await api({
          url: SummaryApi.getAllProperties.url,
          method: SummaryApi.getAllProperties.method,
        });

        const data = res.data?.data || [];

        // 🔥 mapping (same as your listing page)
        const mapped = data.map((p) => ({
          id: p._id,
          title: p.title?.trim(),
          category: p.category?.trim() || "Other",
          location: p.location?.trim(),
          size: p.landSize,
          road: p.roadAccess,
          water: p.waterSource,
          legal: p.legalStatus,
          pricing: p.pricing,
          image:
            p.heroImage?.url ||
            p.gallery?.[0]?.url ||
            Image
        }));

        // 🔥 UNIQUE CATEGORY (1 property per category)
        const uniqueByCategory = Object.values(
          mapped.reduce((acc, item) => {
            if (!acc[item.category]) {
              acc[item.category] = item;
            }
            return acc;
          }, {})
        );

        setProperties(uniqueByCategory);

      } catch (err) {
        console.error("Explore fetch error:", err);
      }
    };

    fetchProperties();
  }, []);

  return (
    <section className="container mx-auto mb-12 px-4">
      <div>
      <div className="text-center mb-6">

        <h2 className="text-4xl md:text-5xl font-medium text-black mb-6 font-times">
          Explore Our Properties
        </h2>

        <p className="text-black mb-5">
          Browse our latest and handpicked properties available for sale and rent.
        </p>
        </div>
        {/* 🔥 LIST */}
        <div className="space-y-10">
          {properties.length > 0 ? (
            properties.map((property) => (
              <PropertyCard key={property.id} data={property} />
            ))
          ) : (
            <p className="text-gray-400">No properties found</p>
          )}
        </div>

        {/* BUTTON */}
        <div className="flex justify-center mt-12">
          <button
            onClick={() => navigate("/properties")}
            className="bg-[#45A301] text-white px-5 py-2.5 rounded-lg flex items-center gap-2 hover:bg-[#3e9202] transition"
          >
            Explore Property
            <FaArrowRightLong />
           
          </button>
        </div>

      </div>
    </section>
  );
}